export class StatusInfo {
   status: boolean;
   startDate: string;
   endDate: string;
}
